<style>
.disabled{
  background-color: #efefef;
}
</style>
<template>
  <div class="shoppingCart">
     

    <div>
       <div class="list">
        <div
          class="item acea-row row-between-wrapper"
          v-for="(item, index) in orderInfo.cartInfo"
          :key="index"
        >
          <div class="select-btn">
            <div class="checkbox-wrapper">
              <label class="well-check">
                <input
				  class="well-check-input"
                  type="checkbox"
                  name=""
                  value=""
				  :checked="item.checked"
                  @click="switchSelect($event,index)"
                  :disabled="((item.refund.display && item.refund.name != '申请售后' && item.refund.name != '申请退款') || !item.refund.display) ? true : false"
                />
                <i class="icon " :class="((item.refund.display && item.refund.name != '申请售后' && item.refund.name != '申请退款') || !item.refund.display) ? 'icon disabled' : 'icon'"></i>
              </label>
            </div>
          </div>
          <div class="picTxt acea-row row-between-wrapper">
            <div class="pictrue">
              <img
                :src="item.productInfo.attrInfo.image"
                v-if="item.productInfo.attrInfo"
              />
              <img :src="item.productInfo.image" v-else />
            </div>
            <div class="text">
              <div class="line1">{{ item.productInfo.store_name }}
                <span style="font-size: 0.28rem;color: #999;float: right;">
              ￥{{
              item.productInfo.attrInfo
                ? item.productInfo.attrInfo.price
                : item.productInfo.price
            }} x {{ item.cart_num }}
            </span> </div>

              <div class="infor line1" v-if="item.productInfo.attrInfo">
        <p>{{ item.productInfo.attrInfo.suk }}</p>
        <p v-if="item.spec_values">{{ item.spec_values }}</p>
              </div>
            </div>
            <div class=" acea-row row-center-wrapper">
              <div
                class="reduce"
                
                @click.prevent="reduce(index)"
              >
              </div>

              
          
            </div>
          </div>
        </div>
      </div>
      </div>
  
 
<div
      class="footer acea-row row-between-wrapper" style="bottom: 0;">
      <div>
        <div class="select-btn">
          <div class="checkbox-wrapper">
            <label class="well-check">
              <input
                type="checkbox"
                name=""
                value=""
                :checked="isAllSelect && uniqueList.length == abledList.length"
				:disabled="abledList.length == 0"
                @click="allChecked"
              />
              <i class="icon" :class="abledList.length == 0 ? 'disabled' : ''"></i>
              <span class="checkAll">全选 ({{ uniqueList.length }})</span>

            </label>
          </div>
        </div>
      </div>
      <div class="money acea-row row-middle" >
        <div class="placeOrder bg-color-red" @click="placeOrder">申请售后</div>
      </div>
  
    </div>
  </div>
</template>

<script>
import { orderDetail, getRefundReason, postOrderRefund, getRefundGoods, RefundVerify } from "@api/order";
import { trim, VUE_APP_API_URL } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";

export default {
  name: "goodsReturn",
  components: {
    VueCoreImageUpload
  },
  data() {
    return {
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      id: this.$route.params.id || 0,
      orderInfo: {},
      reasonList: [],
      disabled: true,
	  isAllSelect: false,
	  abledList: [],
      reason: "",
      refund_reason_wap_explain: "",
      refund_reason_wap_img: [],
	  uniqueList: []
    };
  },
  mounted() {
    this.getOrderDetail();
    this.getRefundReason();
  },
  methods: {
	switchSelect(e,index){
		let that = this,
		  item = that.orderInfo.cartInfo[index],
		  i = that.uniqueList.indexOf(item.unique);
		item.checked = !item.checked;
		if (i !== -1) this.uniqueList.splice(i, 1);
		if(e.target.checked){
			that.uniqueList.push(item.unique)
		}
		if(that.uniqueList.length < that.abledList.length){
			that.isAllSelect = false;
		}else{
			that.isAllSelect = true;
		}
	},
    imageuploaded(res) {
      if (res.status !== 200)
        return this.$dialog.error(res.msg || "上传图片失败");
      this.refund_reason_wap_img.push(res.data.url);
    },
    getOrderDetail() {
	  let that = this;
      orderDetail(that.id)
        .then(res => {
          that.orderInfo = res.data;
		  that.orderInfo.cartInfo.forEach(item => {
			if(item.refund.name == '申请售后' || item.refund.name == '申请退款'){
				that.abledList.push('可售后')
			}  
		  })
        })
        .catch(err => {
          that.$dialog.error(err.msg || "获取订单失败");
        });
    },
     //立即下单；
    placeOrder: function() {
      // let that = this,
      //   list = that.cartList.valid,
      //   id = [];
      // list.forEach(function(val) {
      //   if (val.checked === true) {
      //     id.push(val.id);
      //   }
      // });
      // if (id.length === 0) {
      //   that.$dialog.toast({ mes: "请选择产品" });
      //   return;
      // }
	  if (this.uniqueList.length === 0) {
	    this.$dialog.toast({ mes: "请选择产品" });
	    return;
	  }
      this.$router.push({ path: "/order/refund_type/" + this.uniqueList });
    },
     allChecked: function() {
      let that = this;
      let selectAllStatus = that.isAllSelect;
      selectAllStatus = !selectAllStatus;
      let uniqueList = [];
      // for (let i = 0; i < array.length; i++) {
      //   array[i].checked = selectAllStatus;
      //   checked.push()
      // }
      that.orderInfo.cartInfo.forEach(cart => {
		if(cart.refund.display && (cart.refund.name == '申请售后' || cart.refund.name == '申请退款')){
			cart.checked = selectAllStatus;
			if (selectAllStatus) uniqueList.push(cart.unique);
		}
      });
      // that.$set(that, "cartList", that.cartList);
      that.$set(that, "isAllSelect", selectAllStatus);
      this.uniqueList = uniqueList;
      // cookie.set(CHECKED_IDS, checkedIds);
      // that.carnum();
      // that.countMoney();
    },
    getRefundReason() {
      getRefundReason().then(res => {
        this.reasonList = res.data;
      });
    },
    submit() {
      const refund_reason_wap_explain = trim(this.refund_reason_wap_explain),
        text = this.reason;
      if (!text) return this.$dialog.toast({ mes: "请选择退款原因" });
      postOrderRefund({
        text,
        uni: this.orderInfo.order_id,
        refund_reason_wap_img: this.refund_reason_wap_img.join(","),
        refund_reason_wap_explain
      })
        .then(res => {
          this.$dialog.success(res.msg);
          this.$router.go(-1);
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    }
  }
};
</script>
<style scoped>
.shoppingCart .list{margin-top: 0;}
.line2 {
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
